export function getFileSizeLabel(sizeInKiloByte: number) {
  if (sizeInKiloByte < 1024) {
    return `${sizeInKiloByte} KB`;
  }

  if (sizeInKiloByte < 1024 * 1024) {
    return `${Math.round(sizeInKiloByte / 1024)} MB`;
  }

  return `${Math.round(sizeInKiloByte / (1024 * 1024))} GB`;
}
